import { FOLLOW_OUTAGE_FEEDBACK_MS } from "./follow-retry-constants";

export function shouldReportFollowOutage(
  lastWarnedAt: number | null,
  now: number,
): boolean {
  return (
    lastWarnedAt === null || now - lastWarnedAt >= FOLLOW_OUTAGE_FEEDBACK_MS
  );
}
